import { IAccountBaseWithId } from './account.type'
import { IMessageResponseDto } from './common.type'
import { EUserRoles } from './user.type'

export type ILoginResponse =
  | ILoginResponseSuccess
  | ILoginResponseFinish
  | ILoginResponseTwoFA
  | ILoginJourneyRedirect
  | ILoginRedirectToRegister

export type I2FAVerificationResponse = ILoginResponseSuccess | ILoginJourneyRedirect

export type IWeb3LoginResponse =
  | ILoginResponseSuccess
  | ILoginResponseFinish
  | ILoginResponseRegistration

interface ILoginJourneyRedirect {
  accessToken: string
  refreshToken: string
  journeyRedirect: string
  message: string
}

interface ILoginResponseSuccess {
  message: string
  accessToken: string
  refreshToken: string
  accountId: string | null
  scannerAccountId: string | null
  customer: boolean
}

interface ILoginResponseFinish {
  message: string
  hasFinishedRegistration: boolean
  id: string
  email: string
}

interface ILoginResponseRegistration {
  message: string
  registerByWalletAddress: string
  userId: string
}

interface ILoginRedirectToRegister {
  message: string
  email: string
  redirectToRegister: boolean
}

interface ILoginResponseTwoFA {
  message: string
  methodTwoFA: E2FAMethod
  tokenTwoFA: string
}

export interface IRefreshTokenResponse {
  accessToken: string
  id: string
  roles: EUserRoles[]
}

export interface ITokenRefreshResponse {
  accessToken: string
}

export interface VerifySignupResponse {
  journeyRedirect?: string
  message: string
  accessToken?: string
  refreshToken?: string
  agreement: boolean
  id: string
  accountId: string | null
  scannerAccountId: string | null
  email: string
  customer?: boolean
}

export interface IVerifyResetPasswordResponse extends IMessageResponseDto {
  email: string
  agreement: boolean
  agreement_with_account: boolean
  id: string
  registrationToken?: string
}

export interface IVerifyEmailResponse {
  message: string
  accessToken?: string
  refreshToken?: string
  agreement: boolean
  id: string
  accountId: string | null
  scannerAccountId: string | null
  email: string
  registrationToken?: string
  withoutAccount: boolean
}

export interface IForgotPasswordDto {
  email: string
  journeyRedirect: string
}

export interface IResetPasswordDto {
  password: string
  token: string
}

export interface IForgotPasswordRespDto {
  message: string
  reset_password_token: string
}

export interface LoginUserDto {
  email: string
  password: string
  rememberMe: boolean
  token?: string
  connectToXProvider?: boolean
  preRegisteredUserId?: string
}

export interface ILoginUserWeb3Dto {
  address: string
}

export interface ISignupUserRespDto {
  activation_token: string
  message: string
}

export interface ISignupExisitingAccount
  extends Pick<
    IAccountBaseWithId,
    'id' | 'address' | 'website' | 'country' | 'region' | 'account_holder'
  > {
  hasOwner: boolean
}

export interface IVerificationCodeForm {
  code: string
}

export interface ResetDto {
  password: string
}

export interface ResetDtoConfirm extends ResetDto {
  passwordConfirm: string
}

export interface IUserLogin {
  email: string
  password: string
  rememberMe: boolean
}

export interface IUserSignupForm {
  email: string
  password: string
  account_holder?: string
  account_website?: string
  agreement: boolean
  withExistingAccount: boolean
  buisness: boolean
}

export interface IUserSignupDto {
  token?: string
  email: string
  password: string
  agreement: boolean
  account_holder?: string
  account_website?: string
  accountId?: string
  withoutExistCheck?: boolean
  journeyRedirect: string
  customer: boolean
}

export interface IFinishUserSignupDto {
  id?: string
  account_holder?: string
  agreement: boolean
  email: string
  password: string | null
  customer: boolean
}

export interface IFinishUserSignupForm {
  id?: string
  account_holder?: string
  agreement: boolean
  email: string
  password: string | null
}

export interface IFinishUserSignupResponse {
  accessToken: string
  refreshToken: string
  message: string
  accountId: string | null
  scannerAccountId: string | null
  customer: boolean
}

export interface IFinishUserSignup extends Omit<IFinishUserSignupForm, 'id'> {
  buisness: boolean
}

export interface IUserAuthDto {
  message: string
  roles: EUserRoles[]
  id: string
}

export interface ISignInEmailVerificationDto {
  email: string
  id: string
}

export interface ISignInEmailVerification {
  email: string
}

export interface ISignInEmailVerificationResponse {
  message?: string
  isEmailTaken?: boolean
  activation_token?: string
}

export interface IConfirmLoginByProviderDto {
  email: string
  id: string
}

export interface IConfirmLoginByProviderResponse {
  message: string
  accessToken?: string
  refreshToken?: string
  agreement?: boolean
  accountId?: string
  scannerAccountId: string | null
}

export interface ISend2FAVerificationEmailDto {
  token: string
  enableTimeout?: boolean
}

export interface I2FAVerificationDto {
  code: string
  token: string
}

export enum E2FAMethod {
  Email = 'email',
  Totp = 'totp',
}
